import {
  faCircleXmark,
  faMagnifyingGlass,
} from '@fortawesome/pro-regular-svg-icons';
import { Input, InputProps } from '../input/input';
import { F0 } from '@client/new/helpers/types';
import { useEffect, useRef, useState } from 'react';
import { textColorsVars } from '@design-system/vars.css';

export const SearchInput = ({
  onClear,
  ...p
}: InputProps & { onClear: F0 }) => {
  const r = useRef<HTMLInputElement>(null);
  const [clicked, setClicked] = useState(0);
  useEffect(() => {
    if (r.current) r.current.focus();
  }, [clicked]);
  return (
    <Input
      {...p}
      noBorder
      ref={r}
      autoFocus
      startIcon={{
        icon: faMagnifyingGlass,
        color: textColorsVars['N-60'],
      }}
      endIcon={
        p.value
          ? {
              icon: faCircleXmark,
              onClick: () => {
                onClear();
                setClicked(new Date().getTime());
              },
            }
          : undefined
      }
    />
  );
};
